import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuditRoutingModule } from './audit-routing.module';
import { InsertCodeComponent } from './insert-code/insert-code.component';
import { SingleAuditComponent } from './audit/single-audit/single-audit.component';
import { EnvelopeAuditComponent } from './audit/envelope-audit/envelope-audit.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {HttpClientModule} from "@angular/common/http";
import {InfinityModule} from "../core/shared-modules/infinity.module";
import {TranslateModule} from "@ngx-translate/core";
import { EvidenceSidebarComponent } from './audit/components/evidence-sidebar/evidence-sidebar.component';
import { EvidenceListItemComponent } from './audit/components/evidence-list-item/evidence-list-item.component';
import { EvidenceSignSidebarComponent } from './audit/components/evidence-sign-sidebar/evidence-sign-sidebar.component';


@NgModule({
    declarations: [
        InsertCodeComponent,
        SingleAuditComponent,
        EnvelopeAuditComponent,
        EvidenceSidebarComponent,
        EvidenceListItemComponent,
        EvidenceSignSidebarComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        InfinityModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        AuditRoutingModule
    ]
})
export class AuditModule { }
